import { FleekError } from './FleekError';

type PermissionScopeErrorOptions = {
  scope: string;
};

export class PermissionScopeError extends FleekError<PermissionScopeErrorOptions> {
  public name = 'PermissionScopeError';

  toString = () => `Permission scope ${this.data.scope} doesn't exist.`;
}
